/*eslint-disable */

import EmojiPicker from 'vue-emoji-picker'
import Push from 'push.js';
import accessFeaturesForBlurb from '@/components/public/access-features-of-package-popup';
import axios from 'axios';
import { bus } from '@/main';
import createGroupTeams from "@/components/private/workspace/create-group-teams/index.vue";
import forwardMsgPopup from "@/components/private/workspace/forward-msg-popup/index.vue";
import { mapGetters } from 'vuex';
import messageSearchPopup from "@/components/private/workspace/message-search-popup/index.vue";
import moment from 'moment';
import msgDeletePopup from "@/components/private/workspace/msg-delete-popup/index.vue";
import percentageLoader from "@/components/common/percentage-loader-f-file";
import pinnedChatRoom from "@/components/private/workspace/chat-room-pinned-popup/index.vue";
import root from '@/_helpers/roots';
import selfUserStatus from "@/components/private/workspace/self-user-status/index.vue";
import suggestionUserListForChat from "@/components/private/workspace/chat-for-user-suggestion-list/index.vue";
import toast from '@/services/toast';
import updateGroupIcon from "@/components/private/workspace/update-group-icon/index.vue";
import updateGroupInfo from "@/components/private/workspace/update-group-info/index.vue";
import updateGroupName from "@/components/private/workspace/update-group-name/index.vue";
import videoSocketRef from "@/videoNotificationSocket";

let UploadMsgFileURL = root.uploadMsgFileUrl.link;

const $ = window.jQuery = require('jquery');
export default {
  name: 'chat-info-section',
  components: {
    'create-group': createGroupTeams,
    'update-group-info': updateGroupInfo,
    'update-group-name': updateGroupName,
    'update-group-icon': updateGroupIcon,
    'msg-delete-popup': msgDeletePopup,
    'pinned-room-popup': pinnedChatRoom,
    forwardMsgPopup,
    selfUserStatus,
    'suggestion-user-list': suggestionUserListForChat,
    'access-feature-of-blurb': accessFeaturesForBlurb,
    'message-search-popup' : messageSearchPopup,
    percentageLoader,
    EmojiPicker
  },
  props: ['selectedChatRoomData', 'msgListOfChat', 'welcomeBlurbState'],
  directives: {
    focus: {
      inserted(el) {
        el.focus()
      },
    },
  },
  data() {
    return {
      selectedChatFromUserDetails: null,
      message: '',
      submitted: false,
      selfUserInfo: null,
      userId: '',
      roomChatId: '',
      checkSocketId: '',
      socketCheck: '',
      listLoading: false,
      chatId: '',
      checkDataTaskModal: false,
      blockedUserId: '',
      blockedUserEmail: '',
      chatUserListes: [],
      uploadFile: null,
      filename: '',
      imgSrc: '',
      fileMessage: '',
      roomChatIdForFile: '',
      uploadedFileUrl: '',
      videoSocketStart: '',
      is_superuser: false,
      notConnectedUserDetails: '',
      notConnectedUserPopup: false,
      checkDataTaskModal: false,
      chatRequestDetails: '',
      blockSelectUser: false,
      msgNextPageLoader: '',
      selectedRoomIdForChatStart: '',
      chatAllListResults: [],
      chatRepeatedDateList: [],
      msgApiLoader: false,
      msgValue: '',
      yScrollHeight: '',
      groupRoomChatList: {},
      group_details_info_state: false,
      someInfoOfGroupState: null,
      leaveGroupRoomPopupState: false,
      deleteGroupInfoPopup: false,
      leaveGroupRoomId: '',
      exitGroupName: '',
      updateGroupInfoPopup: false,
      updateGroupInfoId: '',
      groupIdForAdmin: '',
      groupNameForAdmin: '',
      userIdForAdmin: '',
      makeGroupAdminOfUserPopupState: false,
      removeUserIdForGroup: '',
      removeUserForGroupId: '',
      removeUserForGroupName: '',
      removeUserDetailForGroup: false,
      hasInternetConnection: true,
      isOnline: true,
      selfUserId: '',
      checkRoomSocketStatus: false,
      selection_type: 'press_enter',
      messageFeatureStates: false,
      updateGroupNamePopup: false,
      updateGroupNameId: '',
      updateGroupIconPopup: false,
      updateGroupIconId: '',
      deleteMessageDataObj: {
        id: '',
        text: '',
        time: '',
        createdBy: ''
      },
      deleteMsgPopupState: false,
      replyMsgDataObj: {
        data: '',
        status: '',
        chatType: ''
      },
      replyMsgAlertState: false,
      replyMsgForSeletedId: '',
      totalChatListOfData: null,
      totalChatListOfArray: [],
      totalChatListOfLoadMore: '',
      clickOnFirstItemOfChat: false,
      pinnedChatRoomList: [],
      pinnedRoomPopupState: false,
      pinnedRoomId: '',
      pinnedRoomStatus: '',
      selectedRoomOfChatUpperInfo: {
        pinned: Boolean,
        chat_room: ''
      },
      forwardMsgPopup: false,
      suggestionUserListState: false,
      suggestionUserListData: {
        handle: ''
      },
      messageContentDraftValue: '',
      suggestionUserListStateForFileAttach: false,
      accessFeaturesOfPackageState: false,
      individualActivityTrackerState: false,
      chatListAPILoader: true,
      TypingEventForSelectedUserId: '',
      typingGroupUsersInfoState: '',
      typingGroupUsersNameState: '',
      typingUserInfoState: '',
      messageListResultsDto: null,
      userSearchListTabs: false,
      welcomeBlurbsPopupState: false,
      messageSearchPopupState:false,
      chatRoomInfoForSearch:null,
      multipleMessageArr:[],
      multiMessageOptionEnabled:false,
      uploadProgress:0,
      search:'',
      emojis:["👍", "👎","😭", "😕", "😐", "😊", "😍",]
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters'
    ]),
    getSelfUserInfoFun() {
      this.selfUserInfo = this.$store.getters.acUserDetailsStateGetters.data
      return
    },
    getSelectedChatRoomData() {
      return this.selectedChatRoomData;
    },
    welcomeBlurbStateFunc(){
      return this.welcomeBlurbState;
    }
   
  },
  mounted() {
    if(this.selectedChatRoomData){
      this.selectedChatFromUserDetails = this.selectedChatRoomData
      if (this.selectedChatFromUserDetails.is_group_chat) {
        this.getUserDetailsWithGroupChatFun(this.selectedChatRoomData);
      } else {
        this.opnedChatRoomWithSelectedUserFun(this.selectedChatRoomData);
      }
    }
    if(this.welcomeBlurbState){
      this.welcomeBlurbsPopupState = true
    }
    this.selfUserId = localStorage.getItem('LoginedUserID')
    this.getSelfUserInfoFun

    function onGranted() {
      Push.Permission.GRANTED;
    }

    function onDenied() {
      Push.Permission.DENIED;
    }
    Push.Permission.request(onGranted, onDenied)
    // Router Leave Of The Workspace Event Listener
    bus.$on('workspaceRouterLeaveEvntBus', (data) => {
      if (data == "Router_leave") {
        this.checkSocketId = ''
        if (this.socketCheck) {
          this.socketCheck.close();
        }
        this.checkRoomSocketStatus = true
      }
    })
    // Typing For Selected User Event Listener
    bus.$on('TypingEventForSelectedUserBus', (data) => {
      this.typingUserInfoState = data
      if (data.message == 'stop') {
        this.typingUserInfoState = '';
      }
    })
    // Typing For Selected Group Event Listener
    bus.$on('TypingEventForSelectedGroupBus', (data) => {
      this.typingGroupUsersInfoState = data
      if (data.message == 'stop') {
        this.typingGroupUsersInfoState = '';
        this.typingGroupUsersNameState = ''
      }
    })
    bus.$on('accessFeaturesOfPackageStateBus', (data) => {
      this.accessFeaturesOfPackageState = data;
    });
    bus.$on('MessageDeleteForChatOfAllNotification', (data) => {
      let dateTimeAdd = [moment(data.targetForChatMsgTime).format('h:mm a')];
      $('#chatMessageId' + data.targetForChatMsgId + ' ' + '.dropdown').remove()
      $('#chatMessageId' + data.targetForChatMsgId + ' ' + '.show_msg_of_reply_wrp').remove()
      $('#chatMessageId' + data.targetForChatMsgId + ' ' + 'label').remove()
      $('#chatMessageId' + data.targetForChatMsgId + ' ' + '.chat_in_msg_box_wrp').addClass('delete_msg_show_box')
      $('#chatMessageId' + data.targetForChatMsgId + ' ' + 'a').html("<i aria-hidden='true' class='fa fa-ban'></i> This message was deleted")
      $('#chatMessageId' + data.targetForChatMsgId + ' ' + '.msg_in_file').html("<i aria-hidden='true' class='fa fa-ban'></i> This message was deleted")
    })
    bus.$on('msgIndicationStateBus', (data) => {
      if (!data) return;
      if (this.selectedChatFromUserDetails.id == data.selfUserID) {
        if (data.ingroupusers) return;
        $('.msg_sent_ind').addClass('froce_read')
        $('.msg_unsent_ind').addClass('froce_read')
      } else if (data.ingroupusers) {
        if (!this.selectedChatFromUserDetails.is_group_chat) return;
        if (this.selectedChatFromUserDetails.id == data.targetForChatUserId) {
          $('.msg_indication').removeClass('msg_unsent_ind')
          $('.msg_indication').addClass('msg_sent_ind')
        }
      }
    })
    bus.$on('updateGroupInfoDataBus', (data) => {
      this.selectedChatFromUserDetails = data
    })
    bus.$on('updateCurrentUserChatUpperInfoDataBus', (data) => {
      this.selectedRoomOfChatUpperInfo.pinned = data.pinned
      this.selectedRoomOfChatUpperInfo.chat_room = data.chat_room
    })
    bus.$on('updateGroupIconPopupStateBus', (data) => {
      this.updateGroupIconPopup = data
    })
    bus.$on('updateGroupInfoPopupStateBus', (data) => {
      this.updateGroupInfoPopup = data
    })
    bus.$on('updateGroupNamePopupStateBus', (data) => {
      this.updateGroupNamePopup = data
    })
    // connection request notification of workspace menu for code here
    // Enter Loader Hide Code Here
    var _self = this
    $('#chat_msg_list_scroll').on("scroll", function () {
      var yScrollHeight;
      var elmntList = document.getElementById("chat_msg_list_scroll");
      yScrollHeight = elmntList.scrollHeight
      if (0 == $('#chat_msg_list_scroll').scrollTop()) {
        if (_self.msgNextPageLoader) {
          _self.msgApiLoader = true
          axios.get(_self.msgNextPageLoader).then((response) => {
            _self.msgNextPageLoader = ''
            if (response.status == '200') {
              _self.msgNextPageLoader = response.data.data.next
              _self.msgApiLoader = false
              _self.chatAllListResults = [].concat(_self.chatAllListResults, response.data.data.results);
              _self.chatRepeatedDateList = [].concat(response.data.data.repeated_dates_arr);
              setTimeout(() => {
                var recentScrlHeight = elmntList.scrollHeight
                elmntList.scrollTop = recentScrlHeight - yScrollHeight
              }, 10)
            }
          }).catch((err) => {})
        }
      }
    });
    bus.$on('deleteMsgPopupStateBus', (data) => {
      this.deleteMsgPopupState = data
    })
    bus.$on('pinnedRoomPopupStateBus', (data) => {
      this.pinnedRoomPopupState = data
    })
    bus.$on('forwardMsgPopupBus', (data) => {
      $('.live_msg_f_label').removeClass('d-block')
      $('.chat_msg_li').removeClass('selected')
      $('.live_msg').removeClass('selected')
      this.forwardMsgPopup = data
      this.multiMessageOptionEnabled = false
      this.multipleMessageArr = []
    })
    bus.$on('suggestionUserListStateBus', (data) => {
      this.suggestionUserListState = data
      let valueSpilt = this.messageContentDraftValue.split('@')
      if (valueSpilt.length == 2) {
        this.messageContentDraftValue = valueSpilt[0] + '@' + this.suggestionUserListData.handle
      } else if (valueSpilt.length == 3) {
        this.messageContentDraftValue = valueSpilt[0] + '@' + valueSpilt[1] + '@' + this.suggestionUserListData.handle
      } else if (valueSpilt.length == 4) {
        this.messageContentDraftValue = valueSpilt[0] + '@' + valueSpilt[1] + '@' + valueSpilt[2] + '@' + this.suggestionUserListData.handle
      }
      $('#chat-message-reply-input').focus()
    })
    bus.$on('suggestionUserListStateForFileAttachBus', (data) => {
      this.suggestionUserListStateForFileAttach = data
      this.userNameMentionDataForAttachment()
    })
    bus.$on('individualActivityTrackerStateBus', (data) => {
      this.individualActivityTrackerState = data
    })
    bus.$on('messageSearchPopupStateBus', (data) => {
      this.messageSearchPopupState = data
    })
  },
  methods: {
    insertEmojiMethod(emoji) {
      this.messageContentDraftValue += emoji
    },
    /*
    * Message Search Popup For Method Here
    */
    messageSearchPopupEnableMethod(){
      this.messageSearchPopupState = true
      document.body.classList.add('body_right_scroll_remove')
    },
    /*
    * This Will Check Blocked User Method Here
    */
    blockedUserFun(id, email) {
      this.blockedUserId = id
      this.blockedUserEmail = email
      this.blockSelectUser = true
    },
    confirmBlockedUser() {
      let data = {
        blocked_user: this.blockedUserId
      }
      this.listLoading = true
      this.$store.dispatch('createBlockUserFun', data)
        .then((res) => {
          bus.$emit('loadBeforeComponentsStateBus', true)
          this.$store.dispatch('getAllLeftChatListDetailsFun').then((res) => {
            this.blockedUserId = ''
            this.blockedUserEmail = ''
            this.blockSelectUser = false
            this.listLoading = false
            toast.success(res.data.msg);
          })
        }).catch((error) => {
          toast.error(error.data.data.non_field_errors || error.data.msg)
          this.listLoading = false
        })
    },
    noConfirmBlockedUser() {
      this.blockedUserId = ''
      this.blockedUserEmail = ''
      this.blockSelectUser = false
    },
    /*
     * This Will Check Blocked User Method Here End
     */
    selectedOptionMethod(item) {
      this.selection_type = item
      this.messageFeatureStates = false
    },
    messageFeatureStatesMethod() {
      if (this.messageFeatureStates) {
        this.messageFeatureStates = false
      } else {
        this.messageFeatureStates = true
        var _self = this
        $(document).click(function (event) {
          //if you click on anything except the modal itself or the "open modal" link, close the modal
          if (!$(event.target).closest(".option_btn_wrp").length) {
            _self.messageFeatureStates = false
          }
        });
      }
    },
    /*
     * this will get group details again
     */
    getAgainGroupDetailsByIdFun(updateGroupInfoID) {
      this.$store.dispatch('getGroupChatDetailsByIdFun', {
        id: updateGroupInfoID
      }).then((res) => {
        this.selectedChatFromUserDetails = res.data.data
      })
    },
    removedUserToGroupAdminPopupDisabled() {
      this.removeUserIdForGroup = ''
      this.removeUserForGroupId = ''
      this.removeUserForGroupName = ''
      this.removeUserDetailForGroup = false

    },
    removedUserToGroupAdminPopupEnabled(removeUserDetails, removeGroupId, removeGroupName) {
      this.removeUserIdForGroup = removeUserDetails
      this.removeUserForGroupId = removeGroupId
      this.removeUserForGroupName = removeGroupName
      this.removeUserDetailForGroup = true
    },
    removedUserToGroupAdminMethod() {
      var sentData = {
        room_id: this.removeUserForGroupId
      }
      this.$store.dispatch('removedUserFromGroupAdminFun', {
        data: {
          id: this.removeUserIdForGroup.id,
          data: sentData
        }
      }).then((res) => {
        this.getAgainGroupDetailsByIdFun(this.removeUserForGroupId)
        this.removedUserToGroupAdminPopupDisabled()
        this.getGroupRoomListAgain()
      }).catch((err) => {})
    },
    removedAdminToGroupMethod(groupRoomId, userInfo) {
      var UserId = []
      UserId.push(userInfo.id)
      var sentData = {
        room_id: groupRoomId,
        users: UserId
      }
      this.$store.dispatch('removedAdminFromGroupFun', sentData).then((res) => {
        toast.success(`Removing ${userInfo.first_name} ${userInfo.last_name} as a group admin`);
        this.getAgainGroupDetailsByIdFun(groupRoomId)
        this.getGroupRoomListAgain()
      }).catch((err) => {})
    },
    makeUserToGroupAdminPopupDisabled() {
      this.groupIdForAdmin = ''
      this.userIdForAdmin = ''
      this.makeGroupAdminOfUserPopupState = false
    },
    makeUserToGroupAdminPopupEnabled(groupName, groupId, UserInfo) {
      this.groupIdForAdmin = groupId
      this.groupNameForAdmin = groupName
      this.userIdForAdmin = UserInfo
      this.makeGroupAdminOfUserPopupState = true
    },
    makeUserToGroupAdminMethod() {
      var UserId = []
      UserId.push(this.userIdForAdmin.id)
      var sentData = {
        room_id: this.groupIdForAdmin,
        users: UserId
      }
      this.$store.dispatch('makeGroupAdminFun', sentData).then((res) => {
        this.getAgainGroupDetailsByIdFun(this.groupIdForAdmin)
        this.makeUserToGroupAdminPopupDisabled()
        this.getGroupRoomListAgain()
      }).catch((err) => {})
    },
    /*
     * This Methods Code For Some Group Action
     */
    checkTheGroupAdminAccessFun(groupData) {
      for (var i = 0; i < groupData.length; i++) {
        if (groupData[i].user.id == this.selfUserInfo.id) {
          return groupData[i].is_admin;
        }
      }
    },
    updateGroupIconPopupFun(groupId) {
      this.updateGroupIconPopup = true,
        this.updateGroupIconId = groupId
      $('body').addClass('body_right_scroll_remove')
    },
    updateGroupInfoPopupFun(groupId) {
      this.updateGroupInfoPopup = true,
        this.updateGroupInfoId = groupId
      $('body').addClass('body_right_scroll_remove')
    },
    updateGroupNamePopupFun(groupId) {
      this.updateGroupNamePopup = true,
        this.updateGroupNameId = groupId
      $('body').addClass('body_right_scroll_remove')
    },
    leaveGroupRoomPopupOpned(id, groupName) {
      this.leaveGroupRoomId = id
      this.exitGroupName = groupName
      this.leaveGroupRoomPopupState = true
    },
    deleteGroupRoomPopupOpned(id, groupName) {
      this.leaveGroupRoomId = id
      this.exitGroupName = groupName
      this.deleteGroupInfoPopup = true
    },
    deleteGroupRoomPopupClosed() {
      this.deleteGroupInfoPopup = false
      this.leaveGroupRoomId = ''
      this.exitGroupName = ''
    },
    leaveGroupRoomPopupClosed() {
      this.leaveGroupRoomPopupState = false
      this.leaveGroupRoomId = ''
      this.exitGroupName = ''
    },
    deleteGroupRoomMethod() {
      this.$store.dispatch('deleteGroupInfoAction', {
        id: this.leaveGroupRoomId
      }).then((res) => {
        if (res.data.code == '2000') {
          this.getGroupRoomListAgain()
          this.groupSomeInfoDisabled()
          this.deleteGroupRoomPopupClosed()
          $('.chat_user_listed').removeClass('active');
          $('.chat_user_listed').first().addClass('active');
          setTimeout(() => {
            document.querySelector('.chat_user_listed.active .chats_tab_name').click()
          }, 500)
        }
      }).catch((err) => {

      })
    },
    leaveGroupRoomMethod() {
      this.$store.dispatch('leaveRoomGroupByIdFun', {
        room_id: this.leaveGroupRoomId
      }).then((res) => {
        if (res.data.code == '2000') {
          this.getGroupRoomListAgain()
          this.groupSomeInfoDisabled()
          this.leaveGroupRoomPopupClosed()
          $('.chat_user_listed').removeClass('active');
          $('.chat_user_listed').first().addClass('active');
          setTimeout(() => {
            document.querySelector('.chat_user_listed.active .chats_tab_name').click()
          }, 500)
        }
      }).catch((err) => {

      })
    },
    groupSomeInfoEnabled(data) {
      this.someInfoOfGroupState = data,
        this.group_details_info_state = true
      $(document).click(function (event) {
        if (!$(event.target).closest(".some_details_of_group_wrp, .group_details_btn, .remove_data_task_modal, .create_group_team_popup_wrp, .group_info_show_btn").length) {
          if ($('.group_cross_icon').hasClass('enabled')) {
            document.querySelector('.group_cross_icon .fa').click()
          }
        }
      });
    },
    groupSomeInfoDisabled() {
      this.group_details_info_state = false,
        this.someInfoOfGroupState = {}
    },
    /*
     * This Methods Code Start For Chat Room Specific
     */
    enabledYearDateFun(msgDateTime) {
      var currentLocalDate = moment().format('YYYY');
      var startDateCheck = moment(msgDateTime).format('YYYY')
      if (currentLocalDate > startDateCheck) {
        return true;
      } else {
        return false;
      }
    },
    newline() {},
    send() {},
    checkTheColorFun(allUser, SelectedUser) {
      for (var i = 0; i < allUser.length; i++) {
        if (allUser[i].user.id == SelectedUser.user.id) {
          return allUser[i].colour;
        }
      }
    },
    /*
     * This Methods Code End For Chat Room Specific
     */
    getURLObj() {
      return window.URL || window.webkitURL;
    },
    captureImgOnPasteMethod(e) {
      if (e.clipboardData && e.clipboardData.items) {
        var items = e.clipboardData.items;
        for (var i = 0; i < items.length; i++) {
          if (items[i].type.indexOf('image') !== -1) {
            var blob = items[i].getAsFile()
            var URLObj = this.getURLObj()
            var source = URLObj.createObjectURL(blob);
            this.uploadFile = blob
            this.imgSrc = source
            this.filename = 'Photo'
            e.preventDefault();
          }
        }
      }
    },
    userNameMentionDataForAttachment() {
      let valueSpilt = this.fileMessage.split('@')
      if (valueSpilt.length == 2) {
        this.fileMessage = valueSpilt[0] + '@' + this.suggestionUserListData.handle
      } else if (valueSpilt.length == 3) {
        this.fileMessage = valueSpilt[0] + '@' + valueSpilt[1] + '@' + this.suggestionUserListData.handle
      } else if (valueSpilt.length == 4) {
        this.fileMessage = valueSpilt[0] + '@' + valueSpilt[1] + '@' + valueSpilt[2] + '@' + this.suggestionUserListData.handle
      }
      // setTimeout(() => {
      //   document.getElementById('textarea_for_file_input').focus()
      // }, 100);
    },
    suggestionListPopupClosed() {
      this.suggestionUserListStateForFileAttach = false
      this.suggestionUserListState = false
      this.suggestionUserListData.handle = ''
    },
    getStatusTimeOfMinMethod(sc) {
      var cth = moment().format('HH')
      var ctm = moment().format('mm:ss')
      var sth = moment(sc).format('HH')
      var stm = moment(sc).format('mm:ss')
      var cft = cth * parseInt(60) + parseInt(ctm)
      var sft = sth * parseInt(60) + parseInt(stm)
      var nt = cft - sft
      return nt;
    },
    urlify(text) {
      var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
      return text.replace(urlRegex, function (url, b, c) {
        var url2 = (c == 'www.') ? 'http://' + url : url;
        return '<a href="' + url2 + '" target="_blank" class="hyper_link">' + url + '</a>';
      })
    },
    forwardMsgCheckboxMethod(message, id){
      let e = document.getElementById('msg_input' + id).parentNode
      let $label = e.parentNode
      if(document.getElementById('msg_input' + id).checked == false){
        this.removeObjectWithIdFromForwardMessageMethod(id)
      }else{
        this.multipleMessageArr.push(message)
      }
      if($label.classList.contains("selected")){
        $label.classList.remove("selected");
      }else{
        $label.classList.add("selected");
      }
    },
    removeObjectWithIdFromForwardMessageMethod(id) {
      const objWithIdIndex = this.multipleMessageArr.findIndex((obj) => obj.chat_data.message_id === id);
      if (objWithIdIndex > -1) {
        this.multipleMessageArr.splice(objWithIdIndex, 1);
      }
      return this.multipleMessageArr;
    },
    onchangeOfMsgFrwdMethod(id){
      let e = document.getElementById('msg_input' + id).parentNode
      let $label = e.parentNode
      if($label.classList.contains("selected")){
        $label.classList.remove("selected");
      }else{
        $label.classList.add("selected");
      }
    },
    forwardLiveMsgToUserMethod(item) {
      $('.live_msg_f_label').addClass('d-block')
      this.multipleMessageArr.push(item)
      document.getElementById('msg_input' + item.chat_data.message_id).checked = true
      this.multiMessageOptionEnabled = true
      let messageInputDom = document.querySelector('#chat-message-reply-input');
      messageInputDom.value = ''
      this.messageContentDraftValue = ''
      setTimeout(() => {
        this.onchangeOfMsgFrwdMethod(item.chat_data.message_id);
      },100)
    },
    forwardMsgToUserMethod(item) {
      $('.live_msg_f_label').addClass('d-block')
      this.multipleMessageArr.push(item)
      this.multiMessageOptionEnabled = true
      let messageInputDom = document.querySelector('#chat-message-reply-input');
      messageInputDom.value = ''
      this.messageContentDraftValue = ''
      setTimeout(() => {
        this.onchangeOfMsgFrwdMethod(item.id);
      },100)
    },
    clearMultipleMsgDataMethod() {
      $('.live_msg_f_label').removeClass('d-block') 
      $('.chat_msg_li').removeClass('selected')
      $('.live_msg').removeClass('selected')
      this.multiMessageOptionEnabled = false
      this.multipleMessageArr = []
    },
    forwardMultipleMsgToUserMethod(){
      document.body.classList.add('body_right_scroll_remove')
      this.forwardMsgPopup = true
    },
    repeatedDateCheckFun(currentDate, NextItem) {
      if (NextItem) {
        if (currentDate === NextItem.date) {
          return true
        } else {
          return false
        }
      }
      // for (var i = 0; i < data.length; i++) {
      //   for (const [key, value] of Object.entries(data[i])) {
      //     console.log(key, i, "Checking Key Of Point")
      //   }
      // }
    },
    /*
     * This Will Chat Room Pinned
     */
    pinnedChatRoomMethod(chatRoomStatus, chatRoomId) {
      $('body').addClass('body_right_scroll_remove')
      this.pinnedRoomStatus = chatRoomStatus
      this.pinnedRoomId = chatRoomId
      this.pinnedRoomPopupState = true
    },
    /*
     * This Will Reply Selected Message From Chat
     */
    replyMessageOnChatMethod(chatType, msgData, status) {
      this.replyMsgDataObj.chatType = chatType
      this.replyMsgDataObj.data = msgData
      this.replyMsgDataObj.status = status
      this.replyMsgAlertState = true
      if (status == 'inactive') {
        this.replyMsgForSeletedId = msgData.id
      } else {
        this.replyMsgForSeletedId = msgData.chat_data.message_id
      }
      document.getElementById("chat-message-reply-input").focus();
    },
    cancelReplyMessageOnChatMethod() {
      this.replyMsgDataObj.chatType = ''
      this.replyMsgDataObj.data = ''
      this.replyMsgDataObj.status = ''
      this.replyMsgForSeletedId = ''
      this.replyMsgAlertState = false;
    },
    /*
     * This Will Delete Selected Message From Chat
     */
    deteteMessageFromChatMethod(messageId, MsgText, messageTime, createdBy) {
      this.deleteMessageDataObj.id = messageId
      this.deleteMessageDataObj.time = messageTime
      this.deleteMessageDataObj.text = MsgText
      this.deleteMessageDataObj.createdBy = createdBy
      this.deleteMsgPopupState = true
      $('body').addClass('body_right_scroll_remove')
    },
    /*
     * This Will Scroll Bottom Of ChatBox
     */
    chatScrollBottomMethod() {
      var elmnt = document.getElementById("chat_msg_list_scroll");
      var y = elmnt.scrollHeight;
      var scrollH = elmnt.clientHeight;
      var scrollTop = elmnt.scrollTop
      var FullSH = scrollH + scrollTop
      var scrollD = y - FullSH
      if (parseInt(60) > scrollD) {
        $('#chat_msg_list_scroll').animate({
          scrollTop: y
        }, 20)
      }
    },
    /*
     * This Will Checking Chat Message Position 
     */
    CheckingMessageSentReceivedPositionForGroup(ChatData) {
      if (!ChatData) return;
      if (ChatData.forwarded) {
        if (ChatData.data.user_id == this.selfUserId) {
          return 'recieved';
        } else {
          return 'sent';
        }
      } else {
        if (ChatData.data.user_id) {
          if (ChatData.data.user_id == this.selfUserId) {
            return 'recieved';
          } else {
            return 'sent';
          }
        } else {
          if (ChatData.chat_room_user.user.id == this.selfUserId) {
            return 'recieved';
          } else {
            return 'sent';
          }
        }
      }
    },
    CheckingMessageSentReceivedPositionForSingleRoom(ChatData) {
      if (!ChatData) return;
      if (ChatData.forwarded) {
        if (ChatData.data.user_id == this.selfUserId) {
          return 'recieved';
        } else {
          return 'sent';
        }
      } else {
        if (ChatData.data.user_id) {
          if (ChatData.data.user_id == this.selfUserId) {
            return 'sent';
          } else {
            return 'recieved';
          }
        } else {
          if (ChatData.chat_room_user.user.id == this.selfUserId) {
            return 'sent';
          } else {
            return 'recieved';
          }
        }
      }
    },
    DisabledSelfnameFromChatListMethod(ChatData) {
      if (ChatData.data.user_id) {
        if (ChatData.data.user_id == this.selfUserId) {
          return false;
        } else {
          return true;
        }
      } else {
        if (ChatData.chat_room_user.user.id == this.selfUserId) {
          return false;
        } else {
          return true;
        }
      }
    },
    /*
     * this will check the new message notification
     */
    playSound(sound) {
      if (sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },
    /*
     * Get Group Room List Again
     */
    getGroupRoomListAgain() {
      this.$store.dispatch('getAllLeftChatListDetailsFun').then((res) => {})
    },
    /*
     * this will get group details again
     */
    getAgainGroupDetailsByIdFun(updateGroupInfoID) {
      this.$store.dispatch('getGroupChatDetailsByIdFun', {
        id: updateGroupInfoID
      }).then((res) => {
        this.selectedChatFromUserDetails = res.data.data
      })
    },
    /*
     * This Will Msg Read Status Mehtod Here
     */
    socketMsgReadFun(id, senderId) {
      this.$store.dispatch('msgReadStatusFun', {
        message_id: id,
        user: senderId
      }).then((res) => {}).catch((err) => {})
    },
    /*
     * This Will Opned Chat Room With Selected user Of Contact List Method Here
     */
    opnedChatRoomWithSelectedUserFun(chatRoomInfo) {
      this.chatRoomInfoForSearch = chatRoomInfo
      let roomId = chatRoomInfo.chat_room
      let chatForSelectedUserId = chatRoomInfo.user.id
      let userDetails = chatRoomInfo.user
      let openedRoomChatId = chatRoomInfo
      this.messageContentDraftValue = ''
      var userRoomPinnedState = openedRoomChatId.pinned
      this.cancelReplyMessageOnChatMethod()
      if (this.checkRoomSocketStatus) {
        this.checkRoomSocketStatus = false
      }
      let userChatListing = '#userChatListingId' + roomId;
      $('.chat_user_listed').removeClass('active');
      $(userChatListing).addClass('active');
      if (this.selectedRoomIdForChatStart != roomId) {
        if (this.TypingEventForSelectedUserId) {
          videoSocketRef.emit({
            type: "TypingEventForSelectedUser",
            message: 'stop',
            selfUserID: this.selfUserId,
            targetForChatUserId: this.TypingEventForSelectedUserId,
            second_user_id: this.TypingEventForSelectedUserId
          })
          videoSocketRef.emit({
            type: "TypingEventForSelectedGroup",
            message: 'stop',
            selfUserID: this.selfUserId,
            targetForChatUserId: this.TypingEventForSelectedUserId,
            second_user_id: this.TypingEventForSelectedUserId,
            chatRoomId: this.TypingEventForSelectedUserId
          })
        }
        this.TypingEventForSelectedUserId = chatForSelectedUserId
        this.msgNextPageLoader = ''
        this.selectedRoomIdForChatStart = roomId
        this.selectedChatFromUserDetails = userDetails
        this.selectedRoomOfChatUpperInfo.pinned = userRoomPinnedState
        this.selectedRoomOfChatUpperInfo.chat_room = openedRoomChatId.chat_room
        this.submitted = true
        this.messageListResultsDto = null
        this.chatAllListResults = []
        this.chatRepeatedDateList = []
        $('.live_msg').remove();
        var msgBoxContentEmpty = document.getElementById('list_of_chat_msg_wrp')
        msgBoxContentEmpty.innerHTML = "";
        var createdRoomChatId = openedRoomChatId.chat_room
        this.roomChatIdForFile = createdRoomChatId
        this.roomChatId = createdRoomChatId.replace(/-/g, "")
        this.$store.dispatch('getUserChatDetailsByIdFun', {
          id: createdRoomChatId
        }).then((response) => {
          this.messageListResultsDto = response.data.data
          this.chatAllListResults = [].concat(response.data.data.results)
          this.chatRepeatedDateList = [].concat(response.data.data.repeated_dates_arr)
          this.msgNextPageLoader = response.data.data.next
          bus.$emit('unreadCountClearedForUserBus', true)
          setTimeout(() => {
            var __self = this
            var timeout;
            var elmnt = document.getElementById("chat_msg_list_scroll");
            var y = elmnt.scrollHeight;
            $('#chat_msg_list_scroll').animate({
              scrollTop: y
            }, 20)
            // Message Send Event Will Code Here
            document.querySelector('#chat-message-reply-input').addEventListener('keydown', event => {
              if (event.key === 'PageUp' || event.key === 'PageDown') {
                const cursorPosition = event.key === 'PageUp' ? 0 : event.target.textLength;

                event.preventDefault();
                event.target.setSelectionRange(cursorPosition, cursorPosition);
              }
            });
            document.querySelector('#chat-message-reply-input').onkeyup = function (event) {
              var messageInputDom = document.querySelector('#chat-message-reply-input');
              __self.msgValue = messageInputDom.value;
              if (__self.selection_type == 'press_enter') {
                __self.msgValue = messageInputDom.value;
                if (event.keyCode === 13) {
                  if (event.shiftKey) {
                    event.stopPropagation();
                  } else if (!event.shiftKey) {
                    event.preventDefault();
                    document.querySelector('#chat-message-reply-submit').click();
                  }
                } else {
                  if (messageInputDom.value.length > 0) {
                    videoSocketRef.emit({
                      type: "TypingEventForSelectedUser",
                      message: 'typing',
                      selfUserID: _self.selfUserId,
                      targetForChatUserId: _self.selectedChatFromUserDetails.id,
                      second_user_id: _self.selectedChatFromUserDetails.id,
                    });
                    clearTimeout(timeout)
                    timeout = setTimeout(() => {
                      videoSocketRef.emit({
                        type: "TypingEventForSelectedUser",
                        message: 'stop',
                        selfUserID: _self.selfUserId,
                        targetForChatUserId: _self.selectedChatFromUserDetails.id,
                        second_user_id: _self.selectedChatFromUserDetails.id,
                      })
                    }, 2000)
                  }
                }
              }
            };
            document.querySelector('#chat-message-reply-input').focus();
            document.querySelector('#chat-message-reply-submit').onclick = function (e) {
              var messageInputDom = document.querySelector('#chat-message-reply-input');
              __self.msgValue = messageInputDom.value;
              var message = __self.msgValue;
              var msg = message.replace(/</g, "&lt;").replace(/>/g, "&gt;").trim();
              if (msg !== "") {
                var sentUserInfo = __self.selectedChatFromUserDetails;
                let sentData = {
                  'message': message,
                  type: 'sent',
                  email: sentUserInfo.email,
                  user_id: sentUserInfo.id,
                  name: sentUserInfo.first_name + ' ' + sentUserInfo.last_name,
                  selfUserID: __self.selfUserId,
                  is_read: false,
                }
                const currentUserId = localStorage.getItem('LoginedUserID');
                const payload = {
                  toUserID: sentUserInfo.id,
                  second_user_id: sentUserInfo.id,
                  fromUserID: currentUserId,
                  chatRoomId: createdRoomChatId,
                  senderMsgData: message,
                  msgSenderFullName: __self.selfUserInfo.first_name + ' ' + __self.selfUserInfo.last_name
                };
                videoSocketRef.emit({
                  type: "TypingEventForSelectedUser",
                  message: 'stop',
                  selfUserID: _self.selfUserId,
                  targetForChatUserId: _self.selectedChatFromUserDetails.id,
                  second_user_id: _self.selectedChatFromUserDetails.id
                })
                clearTimeout(timeout)
                if (__self.replyMsgForSeletedId) {
                  socketCheck.send(JSON.stringify({
                    'message': message,
                    'user': sentUserInfo.id,
                    'reply_to_msg': __self.replyMsgForSeletedId,
                    'chat_data': sentData
                  }));
                } else {
                  socketCheck.send(JSON.stringify({
                    'message': message,
                    'user': sentUserInfo.id,
                    'chat_data': sentData
                  }));
                }
                let socketTimeout = setTimeout(function () {
                  bus.$emit('newChatMessage', payload);
                  clearTimeout(socketTimeout);
                }, 2500);
                if (!userRoomPinnedState) {
                  bus.$emit('selfFullChatListOrdChangedBus', roomId)
                }
                messageInputDom.value = '';
                __self.msgValue = ''
                __self.messageContentDraftValue = ''
              var elmnt = document.getElementById("chat_msg_list_scroll");
              var y = elmnt.scrollHeight;
              $('#chat_msg_list_scroll').scrollTop(y)
              _self.cancelReplyMessageOnChatMethod()
            }
            };
          }, 200)
          if (this.messageListResultsDto.results) {
            this.socketMsgReadFun(this.messageListResultsDto.results[0].value.slice(-1)[0].id, chatForSelectedUserId)
          }
        }).catch((err) => {})
        // Web Socket Closed Method Here
        if (this.checkSocketId) {
          if (this.roomChatId != this.checkSocketId) {
            this.checkRoomSocketStatus = true
            this.socketCheck.close();
          }
        }
        // Web Socket Started Method Here
        if (this.roomChatId != this.checkSocketId) {
          var _self = this
          var socketCheck = new WebSocket(
            'wss://' + process.env.VUE_APP_WEBSOCKET_BASE_URL +
            '/ws/chat/' + _self.roomChatId + '/'
          );
          setTimeout(() => {
            if (videoSocketRef.isOpen()) {
              videoSocketRef.emit({
                type: "messageIndicationForChat",
                selfUserID: _self.selfUserId,
                targetForChatUserId: _self.selectedChatFromUserDetails.id,
                second_user_id: _self.selectedChatFromUserDetails.id
              });
            }
          }, 1000)
          _self.checkSocketId = _self.roomChatId
          _self.socketCheck = socketCheck
          socketCheck.onmessage = function (e) {
            _self.userToUserMsgDisplayMethod(e)
          };
          socketCheck.onclose = function (e) {
            if (_self.checkRoomSocketStatus == false) {
              setTimeout(() => {
                // console.log(_self.checkRoomSocketStatus, _self.roomChatId, "Web Socket Reconnecting For User Chat")
                socketCheck = new WebSocket(
                  'wss://' + process.env.VUE_APP_WEBSOCKET_BASE_URL +
                  '/ws/chat/' + _self.roomChatId + '/'
                );
                socketCheck.onmessage = function (e) {
                  _self.userToUserMsgDisplayMethod(e)
                };
              }, 1000)
            } else {
              // console.log(_self.checkRoomSocketStatus, "Socket Closed manually testing")
            }
          };
        }
      }
    },
    userToUserMsgDisplayMethod(e) {
      var _self = this
      var messagesList = document.getElementById('reply_msg_list')
      var checkSelectedUserIdOfChat = _self.selectedChatFromUserDetails.id
      var data = JSON.parse(e.data);
      var message = JSON.parse(data.message);
      var li = document.createElement("div");
      var div = document.createElement("div");
      var p = document.createElement("div");
      var a = document.createElement("a");
      var msg_link = document.createElement("span");
      var fileName = document.createElement("a");
      var img = document.createElement("img");
      var span = document.createElement("span");
      var span2 = document.createElement("span");
      var time_wrp = document.createElement("span");
      var time = document.createElement("time");
      let dateTimeAdd = [moment(message.chat_data.current_time).format('h:mm a')];
      time.appendChild(document.createTextNode(dateTimeAdd));
      time.setAttribute("class", "msg_time");
      time_wrp.setAttribute("class", 'msg_time_wrp');
      li.setAttribute("class", 'live_msg');
      li.appendChild(div);
      p.setAttribute("class", 'chat_in_msg_box_wrp');
      var dropdownDiv = document.createElement("div");
      var msg_toggle_option = document.createElement("span");
      var fa_chevron_down = document.createElement("i");
      var dropdown_menu = document.createElement("ul");
      var reply_li = document.createElement("li");
      var delete_li = document.createElement("li");
      var forwardedMessage_li = document.createElement("li");
      dropdownDiv.setAttribute("class", 'dropdown');
      msg_toggle_option.setAttribute("class", 'msg_toggle_option');
      msg_toggle_option.setAttribute("data-toggle", 'dropdown');
      fa_chevron_down.setAttribute("class", 'fa fa-chevron-down');
      dropdown_menu.setAttribute("class", 'dropdown-menu');
      delete_li.onclick = function () {
        _self.deteteMessageFromChatMethod(message.chat_data.message_id, message.chat_data.message, message.chat_data.current_time, message.chat_data.selfUserID)
      }
      reply_li.onclick = function () {
        _self.replyMessageOnChatMethod('userChat', message, 'live')
      }
      forwardedMessage_li.onclick = function () {
        _self.forwardLiveMsgToUserMethod(message)
      }
      dropdownDiv.appendChild(msg_toggle_option);
      msg_toggle_option.appendChild(fa_chevron_down);
      msg_toggle_option.after(dropdown_menu);
      dropdown_menu.appendChild(reply_li);
      dropdown_menu.appendChild(forwardedMessage_li);
      dropdown_menu.appendChild(delete_li);
      reply_li.appendChild(document.createTextNode('Reply'));
      delete_li.appendChild(document.createTextNode('Delete Message'));
      forwardedMessage_li.appendChild(document.createTextNode('Forward Message'));
      // Forward Label For Code Here
      if(message.forwarded){
        let forwarded_msg_text = document.createElement("span");
        let share_icon = document.createElement("i");
        let forwarded_msg_content = document.createElement("span");
        forwarded_msg_content.appendChild(document.createTextNode('Forwarded'));
        forwarded_msg_text.setAttribute("class", 'forwarded_msg_text');
        share_icon.setAttribute("class", 'fa fa-share');
        forwarded_msg_text.appendChild(share_icon);
        share_icon.after(forwarded_msg_content);
        p.appendChild(forwarded_msg_text)
      }
      // Forward Label For Code Here
      if (message.reply_to_msg) {
        var show_msg_of_reply_wrp = document.createElement("span");
        var show_msg_of_reply_name = document.createElement("span");
        show_msg_of_reply_name.style.color = message.chat_data.colour
        show_msg_of_reply_wrp.style.borderLeftColor = message.chat_data.colour
        var show_msg_of_reply_txt = document.createElement("span");
        show_msg_of_reply_wrp.setAttribute("class", 'show_msg_of_reply_wrp');
        show_msg_of_reply_name.setAttribute("class", 'show_msg_of_reply_name');
        show_msg_of_reply_txt.setAttribute("class", 'show_msg_of_reply_txt');
        show_msg_of_reply_name.appendChild(document.createTextNode(message.reply_to_msg.data.sender_user_detail.first_name + ' ' + message.reply_to_msg.data.sender_user_detail.last_name));
        if (message.reply_to_msg.data.file_is) {
          show_msg_of_reply_txt.appendChild(document.createTextNode(message.reply_to_msg.data.filename))
        } else {
          show_msg_of_reply_txt.appendChild(document.createTextNode(message.reply_to_msg.data.message))
        }
        show_msg_of_reply_wrp.appendChild(show_msg_of_reply_name);
        show_msg_of_reply_name.after(show_msg_of_reply_txt);
        p.appendChild(show_msg_of_reply_wrp);
      }
      p.appendChild(dropdownDiv);
      li.setAttribute("id", 'chatMessageId' + message.chat_data.message_id);
      if (message.chat_data.is_file) {
        div.setAttribute("id", 'live_msg_in_file_recieved');
        // var msgExt = message.message.split(".").slice(-1)[0].substr(0, 3)
        var msgExt = message.message.substr((message.message.lastIndexOf('.') + 1));
        msgExt = msgExt.substring(0, msgExt.lastIndexOf("?"))
        li.appendChild(div);
        div.appendChild(p);
        p.appendChild(span);
        span.setAttribute("class", 'msg_in_file');
        if (msgExt == 'PNG' || msgExt == 'png' || msgExt == 'jpeg' || msgExt == 'jpg' || msgExt == 'svg' || msgExt == 'gif' || msgExt == 'webp') {
          img.setAttribute("src", message.message);
          var msg_img_render_in_chat = document.createElement("span");
          msg_img_render_in_chat.setAttribute("class", 'msg_img_render_in_chat');
          span.appendChild(msg_img_render_in_chat);
          msg_img_render_in_chat.appendChild(a);
          a.setAttribute("href", message.message);
          a.setAttribute("target", "_new");
          a.appendChild(img);
          img.setAttribute("class", 'img-fluid');
        } else {
          img.setAttribute("src", _self.checkFileExtensionForChatMessage(message.message));
          var msg_file_render_in_chat = document.createElement("span");
          msg_file_render_in_chat.setAttribute("class", 'msg_file_render_in_chat');
          span.appendChild(msg_file_render_in_chat);
          msg_file_render_in_chat.appendChild(a);
          a.setAttribute("href", message.message);
          a.setAttribute("target", "_new");
          a.appendChild(img);
          img.setAttribute("class", 'img-fluid');
          var msg_file_name = document.createElement("span");
          msg_file_name.setAttribute("class", 'msg_file_name');
          msg_file_name.appendChild(document.createTextNode(message.message.split('/').slice(-1)[0].split('?')[0]));
          img.after(msg_file_name)
        }
        if (message.chat_data.message) {
          fileName.appendChild(document.createTextNode(message.chat_data.message));
          fileName.setAttribute("href", message.message);
          fileName.setAttribute("class", 'msg_link');
          span.after(fileName);
        }
        span2.appendChild(time);
        span2.setAttribute("class", 'msg_time_wrp');
        p.appendChild(span2);
      }else{
        if (message.chat_data.message.split(':/')[0] == 'http' || message.chat_data.message.split(':/')[0] == 'https') {
          a.setAttribute("href", message.chat_data.message);
          a.setAttribute("target", "_new");
          a.setAttribute("class", 'hyper_link');
          a.appendChild(document.createTextNode(message.chat_data.message));
          p.appendChild(a);
          div.appendChild(p);
          time_wrp.appendChild(time);
          p.appendChild(time_wrp);
        } else {
          a.setAttribute("href", "javascript:void(0)");
          msg_link.setAttribute("class", 'msg_link');
          msg_link.appendChild(document.createTextNode(message.chat_data.message));
          p.appendChild(msg_link);
          div.appendChild(p);
          time_wrp.appendChild(time);
          p.appendChild(time_wrp);
        }
      }
      if (message.chat_data.user_id == checkSelectedUserIdOfChat) {
        var labelReadS = document.createElement("label")
        var labelReadI = document.createElement("i")
        labelReadS.setAttribute("class", 'chat_msg_send_received_action_wrp');
        if (message.chat_data.is_read) {
          labelReadI.setAttribute("class", 'msg_indication msg_read_ind');
        } else {
          if (message.chat_data.read_status_value == 'sent') {
            labelReadI.setAttribute("class", 'msg_indication msg_sent_ind');
          } else {
            labelReadI.setAttribute("class", 'msg_indication msg_unsent_ind')
          }
        }
        labelReadS.appendChild(labelReadI);
        time.after(labelReadS);
        div.setAttribute("class", 'recieved');
      } else {
        div.setAttribute("class", 'sent');
        _self.socketMsgReadFun(message.chat_data.message_id, _self.TypingEventForSelectedUserId)
      }
      // Forward Multiple Checkbox Code Start
      var radioLabel = document.createElement('label');
      radioLabel.setAttribute('class', 'live_msg_f_label');
      radioLabel.setAttribute('for', 'msg_input' + message.chat_data.message_id);
      var customCheckboxSpan = document.createElement('span');
      customCheckboxSpan.setAttribute('class', 'custom_checkbox_span');
      var customCheckboxI = document.createElement('i');
      customCheckboxI.setAttribute('class', 'fa fa-check');
      var radioInput = document.createElement('input');
      var radioInput = document.createElement('input');
      radioInput.setAttribute('type', 'checkbox');
      radioInput.setAttribute('id', 'msg_input' + message.chat_data.message_id);
      radioInput.setAttribute('hidden', 'true');
      radioInput.onclick = function () {
        _self.forwardMsgCheckboxMethod(message, message.chat_data.message_id)
      }
      customCheckboxSpan.appendChild(customCheckboxI);
      radioLabel.appendChild(radioInput);
      radioLabel.appendChild(customCheckboxSpan);
      li.appendChild(radioLabel);
      // Forward Multiple Checkbox Code Start
      messagesList.appendChild(li);
      var elmnt = document.getElementById("chat_msg_list_scroll");
      var y = elmnt.scrollHeight;
      $('#chat_msg_list_scroll').scrollTop(y)
    },
    /*
     * This Will Group Chat Room Created With Selected user Method Here
     */
    getUserDetailsWithGroupChatFun(chatRoomInfo) {
      this.chatRoomInfoForSearch = chatRoomInfo
      let groupId = chatRoomInfo.id
      let groupChatDetails = chatRoomInfo
      this.messageContentDraftValue = ''
      this.cancelReplyMessageOnChatMethod()
      if (this.checkRoomSocketStatus) {
        this.checkRoomSocketStatus = false
      }
      let userChatListing = '#userChatListingId' + groupId;
      $('.chat_user_listed').removeClass('active');
      $(userChatListing).addClass('active');
      if (this.selectedRoomIdForChatStart != groupId) {
        if (this.TypingEventForSelectedUserId) {
          videoSocketRef.emit({
            type: "TypingEventForSelectedUser",
            message: 'stop',
            selfUserID: this.selfUserId,
            targetForChatUserId: this.TypingEventForSelectedUserId,
            second_user_id: this.TypingEventForSelectedUserId
          })
          videoSocketRef.emit({
            type: "TypingEventForSelectedGroup",
            message: 'stop',
            selfUserID: this.selfUserId,
            targetForChatUserId: this.TypingEventForSelectedUserId,
            second_user_id: this.TypingEventForSelectedUserId,
            chatRoomId: this.TypingEventForSelectedUserId
          })
        }
        this.TypingEventForSelectedUserId = groupId
        this.roomChatId = ''
        this.msgNextPageLoader = ''
        this.selectedRoomIdForChatStart = groupId
        this.roomChatId = groupId.replace(/-/g, "")
        this.submitted = true
        this.messageListResultsDto = null
        this.chatAllListResults = []
        this.chatRepeatedDateList = []
        $('.live_msg').remove();
        var msgBoxContentEmpty = document.getElementById('list_of_chat_msg_wrp')
        msgBoxContentEmpty.innerHTML = "";
        this.$store.dispatch('getGroupChatDetailsFun', {
          id: this.selectedRoomIdForChatStart
        }).then((response) => {
          this.messageListResultsDto = response.data.data
          this.chatAllListResults = [].concat(response.data.data.results)
          this.chatRepeatedDateList = [].concat(response.data.data.repeated_dates_arr)
          this.msgNextPageLoader = response.data.data.next
          bus.$emit('unreadCountClearedForGroupBus', true)
          $('.sent_list').remove()
          $('.recieved_list').remove()
          var __self = this
          setTimeout(() => {
            var timeout;
            var elmnt = document.getElementById("chat_msg_list_scroll");
            var y = elmnt.scrollHeight;
            $('#chat_msg_list_scroll').animate({
              scrollTop: y
            }, 20)
            // Message Send Event Will Code Here
            document.querySelector('#chat-message-reply-input').addEventListener('keydown', event => {
              if (event.key === 'PageUp' || event.key === 'PageDown') {
                const cursorPosition = event.key === 'PageUp' ? 0 : event.target.textLength;

                event.preventDefault();
                event.target.setSelectionRange(cursorPosition, cursorPosition);
              }
            });
            document.querySelector('#chat-message-reply-input').onkeyup = function (event) {
              var messageInputDom = document.querySelector('#chat-message-reply-input');
              if (__self.messageContentDraftValue.length >= 1) {
                if (__self.messageContentDraftValue.split('').slice(-1) == '@' || event.key == '@') {
                  __self.suggestionUserListState = true
                }
              } else {
                __self.suggestionUserListState = false
              }
              if (__self.selection_type == 'press_enter') {
                __self.msgValue = messageInputDom.value;
                if (event.keyCode === 13) {
                  if (event.shiftKey) {
                    event.stopPropagation();
                  } else if (!event.shiftKey) {
                    event.preventDefault();
                    document.querySelector('#chat-message-reply-submit').click();
                  }
                } else {
                  if (messageInputDom.value.length > 0) {
                    videoSocketRef.emit({
                      type: "TypingEventForSelectedGroup",
                      message: 'typing',
                      selfUserID: _self.selfUserId,
                      targetForChatUserId: _self.selectedRoomIdForChatStart,
                      ingroupusers: _self.selectedChatFromUserDetails.users,
                      second_user_id: _self.selectedRoomIdForChatStart,
                      chatRoomId: __self.selectedRoomIdForChatStart
                    });
                    clearTimeout(timeout)
                    timeout = setTimeout(() => {
                      videoSocketRef.emit({
                        type: "TypingEventForSelectedGroup",
                        message: 'stop',
                        selfUserID: _self.selfUserId,
                        targetForChatUserId: _self.selectedRoomIdForChatStart,
                        second_user_id: _self.selectedRoomIdForChatStart,
                        chatRoomId: __self.selectedRoomIdForChatStart
                      })
                    }, 2000)
                  }
                }
              }
            };
            document.querySelector('#chat-message-reply-input').focus();
            document.querySelector('#chat-message-reply-submit').onclick = function (e) {
              var messageInputDom = document.querySelector('#chat-message-reply-input');
              __self.msgValue = messageInputDom.value;
              var message = __self.msgValue;
              var msg = message.replace(/</g, "&lt;").replace(/>/g, "&gt;").trim();
              if (msg !== "") {
                let sentData = {
                  'message': message,
                  type: 'sent',
                  email: __self.selfUserInfo.email,
                  user_id: __self.selfUserInfo.id,
                  name: __self.selfUserInfo.first_name + ' ' + __self.selfUserInfo.last_name
                }
                const currentUserId = localStorage.getItem('LoginedUserID');
                const payload = {
                  selfUserID: currentUserId,
                  chatRoomId: __self.selectedRoomIdForChatStart,
                  senderMsgData: __self.selfUserInfo.first_name + ' ' + __self.selfUserInfo.last_name + ' : ' + message,
                  msgSenderFullName: __self.selectedChatFromUserDetails.name,
                  second_user_id: _self.selectedRoomIdForChatStart
                };
                videoSocketRef.emit({
                  type: "TypingEventForSelectedGroup",
                  message: 'stop',
                  selfUserID: _self.selfUserId,
                  targetForChatUserId: _self.selectedRoomIdForChatStart,
                  second_user_id: _self.selectedRoomIdForChatStart,
                  chatRoomId: __self.selectedRoomIdForChatStart
                })
                clearTimeout(timeout)
                if (__self.replyMsgForSeletedId) {
                  socketCheck.send(JSON.stringify({
                    'message': message,
                    'user': currentUserId,
                    'reply_to_msg': __self.replyMsgForSeletedId,
                    'chat_data': sentData
                  }));
                } else {
                  socketCheck.send(JSON.stringify({
                    'message': message,
                    'user': currentUserId,
                    'chat_data': sentData
                  }));
                }
                let socketTimeout = setTimeout(function () {
                  bus.$emit('newChatMessageOfGroupRoom', payload);
                  clearTimeout(socketTimeout);
                }, 2500);
                if (!groupChatDetails.pinned) {
                  bus.$emit('selfFullChatListOrdChangedBus', groupId)
                }
                messageInputDom.value = '';
                __self.msgValue = ''
                __self.messageContentDraftValue = ''
              var elmnt = document.getElementById("chat_msg_list_scroll");
              var y = elmnt.scrollHeight;
              $('#chat_msg_list_scroll').scrollTop(y)
              __self.cancelReplyMessageOnChatMethod()
            }
            };
          }, 200)
          if (this.messageListResultsDto.results) {
            this.socketMsgReadFun(this.messageListResultsDto.results[0].value.slice(-1)[0].id, this.roomChatId)
          }
        }).catch((err) => {})
        // Search User List For Chat Code Here
        if (this.userSearchListTabs == true) {
          this.$store.dispatch('getAllLeftChatListDetailsFun').then((res) => {
            this.totalChatListOfData = res.data.data
            $('.chat_user_listed').removeClass('active');
            let userChatListing = '#userChatListingId' + groupId;
            setTimeout(() => {
              $(userChatListing).addClass('active');
            }, 100);
            this.searchBarForChatClosedFun()
          })
        }
        // Web Socket Closed Method Here
        if (this.checkSocketId) {
          if (this.roomChatId != this.checkSocketId) {
            this.checkRoomSocketStatus = true
            this.socketCheck.close();
          }
        }
        // Web Socket Started Method Here
        if (this.roomChatId != this.checkSocketId) {
          var _self = this
          var socketCheck = new WebSocket(
            'wss://' + process.env.VUE_APP_WEBSOCKET_BASE_URL +
            '/ws/group-chat/' + this.roomChatId + '/'
          );
          setTimeout(() => {
            if (videoSocketRef.isOpen()) {
              videoSocketRef.emit({
                type: "messageIndicationForChat",
                selfUserID: _self.selfUserId,
                targetForChatUserId: _self.selectedChatFromUserDetails.id,
                ingroupusers: _self.selectedChatFromUserDetails.users,
                second_user_id: _self.selectedChatFromUserDetails.id
              });
            }
          }, 1000)
          this.checkSocketId = socketCheck.url.split('/')[5]
          this.socketCheck = socketCheck
          socketCheck.onmessage = function (e) {
            _self.groupMsgDisplayMethod(e)
          };
          socketCheck.onclose = function (e) {
            if (_self.checkRoomSocketStatus == false) {
              setTimeout(() => {
                // console.log(_self.checkRoomSocketStatus, _self.roomChatId, "Socket Reconnecting For Group Chat")
                socketCheck = new WebSocket(
                  'wss://' + process.env.VUE_APP_WEBSOCKET_BASE_URL +
                  '/ws/group-chat/' + _self.roomChatId + '/'
                );
                socketCheck.onmessage = function (e) {
                  _self.groupMsgDisplayMethod(e)
                };
              }, 1000)
            } else {
              // console.log(_self.checkRoomSocketStatus, "Socket Closed manually testing")
            }
          };
        }
      }
    },
    groupMsgDisplayMethod(e) {
      var messagesList = document.getElementById('reply_msg_list')
      var _self = this
      if (_self.selfUserInfo) {
        var currentUserId = _self.selfUserInfo.id
      }
      var data = JSON.parse(e.data);
      var message = JSON.parse(data.message);
      var li = document.createElement("div");
      var div = document.createElement("div");
      var p = document.createElement("div");
      var a = document.createElement("a");
      var fileName = document.createElement("a");
      var img = document.createElement("img");
      var span = document.createElement("span");
      var span2 = document.createElement("span");
      var sender_name = document.createElement("span");
      var time_wrp = document.createElement("span");
      var time = document.createElement("time");
      let dateTimeAdd = [moment(message.chat_data.current_time).format('h:mm a')];
      time.appendChild(document.createTextNode(dateTimeAdd));
      time.setAttribute("class", "msg_time");
      sender_name.setAttribute("class", "message_sender_name");
      sender_name.style.color = message.chat_data.colour
      time_wrp.setAttribute("class", 'msg_time_wrp');
      li.setAttribute("class", 'live_msg');
      li.appendChild(div);
      p.setAttribute("class", 'chat_in_msg_box_wrp');
      var dropdownDiv = document.createElement("div");
      var msg_toggle_option = document.createElement("span");
      var fa_chevron_down = document.createElement("i");
      var dropdown_menu = document.createElement("ul");
      var reply_li = document.createElement("li");
      var delete_li = document.createElement("li");
      var forwardedMessage_li = document.createElement("li");
      dropdownDiv.setAttribute("class", 'dropdown');
      msg_toggle_option.setAttribute("class", 'msg_toggle_option');
      msg_toggle_option.setAttribute("data-toggle", 'dropdown');
      fa_chevron_down.setAttribute("class", 'fa fa-chevron-down');
      dropdown_menu.setAttribute("class", 'dropdown-menu');
      delete_li.onclick = function () {
        _self.deteteMessageFromChatMethod(message.chat_data.message_id, message.chat_data.message, message.chat_data.current_time, message.chat_data.selfUserID)
      }
      reply_li.onclick = function () {
        _self.replyMessageOnChatMethod('groupChat', message, 'live')
      }
      forwardedMessage_li.onclick = function () {
        _self.forwardLiveMsgToUserMethod(message)
      }
      dropdownDiv.appendChild(msg_toggle_option);
      msg_toggle_option.appendChild(fa_chevron_down);
      msg_toggle_option.after(dropdown_menu);
      dropdown_menu.appendChild(reply_li);
      dropdown_menu.appendChild(forwardedMessage_li);
      dropdown_menu.appendChild(delete_li);
      reply_li.appendChild(document.createTextNode('Reply'));
      delete_li.appendChild(document.createTextNode('Delete Message'));
      forwardedMessage_li.appendChild(document.createTextNode('Forward Message'));
      // Forward Label For Code Here
      if(message.forwarded){
        let forwarded_msg_text = document.createElement("span");
        let share_icon = document.createElement("i");
        let forwarded_msg_content = document.createElement("span");
        forwarded_msg_content.appendChild(document.createTextNode('Forwarded'));
        forwarded_msg_text.setAttribute("class", 'forwarded_msg_text');
        share_icon.setAttribute("class", 'fa fa-share');
        forwarded_msg_text.appendChild(share_icon);
        share_icon.after(forwarded_msg_content);
        p.appendChild(forwarded_msg_text)
      }
      // Forward Label For Code Here
      if (message.reply_to_msg) {
        var show_msg_of_reply_wrp = document.createElement("span");
        var show_msg_of_reply_name = document.createElement("span");
        show_msg_of_reply_name.style.color = message.chat_data.colour
        show_msg_of_reply_wrp.style.borderLeftColor = message.chat_data.colour
        var show_msg_of_reply_txt = document.createElement("span");
        show_msg_of_reply_wrp.setAttribute("class", 'show_msg_of_reply_wrp');
        show_msg_of_reply_name.setAttribute("class", 'show_msg_of_reply_name');
        show_msg_of_reply_txt.setAttribute("class", 'show_msg_of_reply_txt');
        show_msg_of_reply_name.appendChild(document.createTextNode(message.reply_to_msg.data.name));
        if (message.reply_to_msg.data.file_is) {
          show_msg_of_reply_txt.appendChild(document.createTextNode(message.reply_to_msg.data.filename))
        } else {
          show_msg_of_reply_txt.appendChild(document.createTextNode(message.reply_to_msg.data.message))
        }
        show_msg_of_reply_wrp.appendChild(show_msg_of_reply_name);
        show_msg_of_reply_name.after(show_msg_of_reply_txt);
        p.appendChild(show_msg_of_reply_wrp);
      }
      p.appendChild(dropdownDiv);
      li.setAttribute("id", 'chatMessageId' + message.chat_data.message_id);
      if (message.chat_data.is_file) {
        div.setAttribute("id", 'live_msg_in_file_recieved');
        var msgExt = message.message.substr((message.message.lastIndexOf('.') + 1));
        msgExt = msgExt.substring(0, msgExt.lastIndexOf("?"))
        li.appendChild(div);
        div.appendChild(p);
        p.appendChild(span);
        span.setAttribute("class", 'msg_in_file');
        if (msgExt == 'PNG' || msgExt == 'png' || msgExt == 'jpeg' || msgExt == 'jpg' || msgExt == 'svg' || msgExt == 'gif' || msgExt == 'webp') {
          img.setAttribute("src", message.message);
          var msg_img_render_in_chat = document.createElement("span");
          msg_img_render_in_chat.setAttribute("class", 'msg_img_render_in_chat');
          span.appendChild(msg_img_render_in_chat);
          msg_img_render_in_chat.appendChild(a);
          a.setAttribute("href", message.message);
          a.setAttribute("target", "_new");
          a.appendChild(img);
          img.setAttribute("class", 'img-fluid');
        } else {
          img.setAttribute("src", _self.checkFileExtensionForChatMessage(message.message));
          var msg_file_render_in_chat = document.createElement("span");
          msg_file_render_in_chat.setAttribute("class", 'msg_file_render_in_chat');
          span.appendChild(msg_file_render_in_chat);
          msg_file_render_in_chat.appendChild(a);
          a.setAttribute("href", message.message);
          a.setAttribute("target", "_new");
          a.appendChild(img);
          img.setAttribute("class", 'img-fluid');
          var msg_file_name = document.createElement("span");
          msg_file_name.setAttribute("class", 'msg_file_name');
          msg_file_name.appendChild(document.createTextNode(message.message.split('/').slice(-1)[0].split('?')[0]));
          img.after(msg_file_name)
        }
        if (message.chat_data.message) {
          fileName.appendChild(document.createRange().createContextualFragment(message.chat_data.message));
          fileName.setAttribute("href", message.message);
          fileName.setAttribute("class", 'msg_link');
          span.after(fileName);
        }
        span2.appendChild(time);
        span2.setAttribute("class", 'msg_time_wrp');
        p.appendChild(span2);
      } else {
        if (message.chat_data.message.split(':/')[0] == 'http' || message.chat_data.message.split(':/')[0] == 'https') {
          a.setAttribute("href", message.chat_data.message);
          a.setAttribute("target", "_new");
          a.setAttribute("class", 'hyper_link');
          a.appendChild(document.createTextNode(message.chat_data.message));
          p.appendChild(a);
          div.appendChild(p);
          time_wrp.appendChild(time);
          p.appendChild(time_wrp);
        } else {
          a.setAttribute("href", "javascript:void(0)");
          a.setAttribute("class", 'msg_link_chat');
          a.appendChild(document.createRange().createContextualFragment(message.chat_data.message));
          p.appendChild(a);
          div.appendChild(p);
          time_wrp.appendChild(time);
          p.appendChild(time_wrp);
        }
      }
      if (message.chat_data.user_id == currentUserId) {
        var labelReadS = document.createElement("label")
        var labelReadI = document.createElement("i")
        labelReadS.setAttribute("class", 'chat_msg_send_received_action_wrp');
        if (message.chat_data.is_group_read) {
          labelReadI.setAttribute("class", 'msg_indication msg_read_ind');
        } else {
          if (message.chat_data.read_status_value == 'sent') {
            labelReadI.setAttribute("class", 'msg_indication msg_sent_ind');
          } else {
            labelReadI.setAttribute("class", 'msg_indication msg_unsent_ind')
          }
        }
        labelReadS.appendChild(labelReadI);
        time.after(labelReadS);
        div.setAttribute("class", 'recieved');
      } else {
        p.prepend(sender_name)
        div.setAttribute("class", 'sent');
      }
      sender_name.appendChild(document.createTextNode(message.chat_data.name));
      _self.socketMsgReadFun(message.chat_data.message_id, _self.roomChatId)
      // Forward Multiple Checkbox Code Start
      var radioLabel = document.createElement('label');
      radioLabel.setAttribute('class', 'live_msg_f_label');
      radioLabel.setAttribute('for', 'msg_input' + message.chat_data.message_id);
      var customCheckboxSpan = document.createElement('span');
      customCheckboxSpan.setAttribute('class', 'custom_checkbox_span');
      var customCheckboxI = document.createElement('i');
      customCheckboxI.setAttribute('class', 'fa fa-check');
      var radioInput = document.createElement('input');
      var radioInput = document.createElement('input');
      radioInput.setAttribute('type', 'checkbox');
      radioInput.setAttribute('id', 'msg_input' + message.chat_data.message_id);
      radioInput.setAttribute('hidden', 'true');
      radioInput.onclick = function () {
        _self.forwardMsgCheckboxMethod(message, message.chat_data.message_id)
      }
      customCheckboxSpan.appendChild(customCheckboxI);
      radioLabel.appendChild(radioInput);
      radioLabel.appendChild(customCheckboxSpan);
      li.appendChild(radioLabel);
      // Forward Multiple Checkbox Code Start
      messagesList.appendChild(li);
      var elmnt = document.getElementById("chat_msg_list_scroll");
      var y = elmnt.scrollHeight;
      $('#chat_msg_list_scroll').scrollTop(y)
    },
    /*
     * This Will Searching User For Chat Method Here
     */
    searchingUserForPersonalChatMethod(chatInfo) {
      let id = chatInfo.id
      this.messageContentDraftValue = ''
      if (this.userSearchListTabs == true) {
        this.cancelReplyMessageOnChatMethod()
        if (this.checkRoomSocketStatus) {
          this.checkRoomSocketStatus = false
        }
        if (this.selectedRoomIdForChatStart != id) {
          let userChatListing = '#userChatListingId' + id;
          $('.chat_user_listed').removeClass('active');
          $(userChatListing).addClass('active');
          if (this.TypingEventForSelectedUserId) {
            videoSocketRef.emit({
              type: "TypingEventForSelectedUser",
              message: 'stop',
              selfUserID: this.selfUserId,
              targetForChatUserId: this.TypingEventForSelectedUserId,
              second_user_id: this.TypingEventForSelectedUserId
            })
            videoSocketRef.emit({
              type: "TypingEventForSelectedGroup",
              message: 'stop',
              selfUserID: this.selfUserId,
              targetForChatUserId: this.TypingEventForSelectedUserId,
              second_user_id: this.TypingEventForSelectedUserId,
              chatRoomId: this.TypingEventForSelectedUserId
            })
          }
          this.TypingEventForSelectedUserId = id
          this.msgNextPageLoader = ''
          this.messageListResultsDto = null
          this.chatAllListResults = []
          this.chatRepeatedDateList = []
          $('.live_msg').remove();
          var messagesList = document.getElementById('reply_msg_list')
          var msgBoxContentEmpty = document.getElementById('list_of_chat_msg_wrp')
          msgBoxContentEmpty.innerHTML = "";
          var ChatId = id
          var selectedChatId;
          let data = {
            users: [ChatId, this.selfUserId],
            is_support_chat: false
          }
          this.$store.dispatch('chatRoomCreatedFun', data).then((res) => {
            var createdRoomChatId = res.data.data.id
            selectedChatId = res.data.data.id;
            this.selectedRoomIdForChatStart = res.data.data.id
            this.roomChatIdForFile = res.data.data.id
            this.roomChatId = createdRoomChatId.replace(/-/g, "")
            this.$store.dispatch('getUserChatDetailsByIdFun', {
              id: createdRoomChatId
            }).then((response) => {
              this.messageListResultsDto = response.data.data
              this.chatAllListResults = [].concat(response.data.data.results)
              this.chatRepeatedDateList = [].concat(response.data.data.repeated_dates_arr)
              this.msgNextPageLoader = response.data.data.next
              $('.live_msg').remove()
              setTimeout(() => {
                var __self = this
                var timeout;
                var elmnt = document.getElementById("chat_msg_list_scroll");
                var y = elmnt.scrollHeight;
                $('#chat_msg_list_scroll').animate({
                  scrollTop: y
                }, 20)
                // Message Send Event Will Code Here
                document.querySelector('#chat-message-reply-input').addEventListener('keydown', event => {
                  if (event.key === 'PageUp' || event.key === 'PageDown') {
                    const cursorPosition = event.key === 'PageUp' ? 0 : event.target.textLength;

                    event.preventDefault();
                    event.target.setSelectionRange(cursorPosition, cursorPosition);
                  }
                });
                document.querySelector('#chat-message-reply-input').onkeyup = function (event) {
                  var messageInputDom = document.querySelector('#chat-message-reply-input');
                  if (__self.selection_type == 'press_enter') {
                    __self.msgValue = messageInputDom.value;
                    if (event.keyCode === 13) {
                      if (event.shiftKey) {
                        event.stopPropagation();
                      } else if (!event.shiftKey) {
                        event.preventDefault();
                        document.querySelector('#chat-message-reply-submit').click();
                      }
                    } else {
                      if (messageInputDom.value.length > 0) {
                        videoSocketRef.emit({
                          type: "TypingEventForSelectedUser",
                          message: 'typing',
                          selfUserID: _self.selfUserId,
                          targetForChatUserId: _self.selectedChatFromUserDetails.id,
                          second_user_id: _self.selectedChatFromUserDetails.id
                        });
                        clearTimeout(timeout)
                        timeout = setTimeout(() => {
                          videoSocketRef.emit({
                            type: "TypingEventForSelectedUser",
                            message: 'stop',
                            selfUserID: _self.selfUserId,
                            targetForChatUserId: _self.selectedChatFromUserDetails.id,
                            second_user_id: _self.selectedChatFromUserDetails.id
                          })
                        }, 2000)
                      }
                    }
                  }
                };
                document.querySelector('#chat-message-reply-input').focus();
                document.querySelector('#chat-message-reply-submit').onclick = function (e) {
                  var messageInputDom = document.querySelector('#chat-message-reply-input');
                  __self.msgValue = messageInputDom.value;
                  var message = __self.msgValue;
                  var msg = message.replace(/</g, "&lt;").replace(/>/g, "&gt;").trim();
                  if (msg !== "") {
                    var sentUserInfo = __self.selectedChatFromUserDetails;
                    let sentData = {
                      'message': message,
                      type: 'sent',
                      email: sentUserInfo.email,
                      user_id: sentUserInfo.id,
                      name: sentUserInfo.first_name + ' ' + sentUserInfo.last_name,
                      selfUserID: __self.selfUserId,
                      is_read: false
                    }
                    const currentUserId = localStorage.getItem('LoginedUserID');
                    const payload = {
                      toUserID: sentUserInfo.id,
                      second_user_id: sentUserInfo.id,
                      fromUserID: currentUserId,
                      chatRoomId: selectedChatId
                    };
                    videoSocketRef.emit({
                      type: "TypingEventForSelectedUser",
                      message: 'stop',
                      selfUserID: _self.selfUserId,
                      targetForChatUserId: _self.selectedChatFromUserDetails.id,
                      second_user_id: _self.selectedChatFromUserDetails.id
                    })
                    clearTimeout(timeout)
                    if (__self.replyMsgForSeletedId) {
                      socketCheck.send(JSON.stringify({
                        'message': message,
                        'user': sentUserInfo.id,
                        'reply_to_msg': __self.replyMsgForSeletedId,
                        'chat_data': sentData
                      }));
                    } else {
                      socketCheck.send(JSON.stringify({
                        'message': message,
                        'user': sentUserInfo.id,
                        'chat_data': sentData
                      }));
                    }
                    let socketTimeout = setTimeout(function () {
                      bus.$emit('newChatMessage', payload);
                      clearTimeout(socketTimeout);
                    }, 2500);
                    bus.$emit('selfFullChatListOrdChangedBus', createdRoomChatId)
                    messageInputDom.value = '';
                    __self.msgValue = ''
                    __self.messageContentDraftValue = ''
                    var elmnt = document.getElementById("chat_msg_list_scroll");
                    var y = elmnt.scrollHeight;
                    $('#chat_msg_list_scroll').scrollTop(y)
                  }
                };
              }, 200)
            })
            // Web Socket Closed Method Here
            if (this.checkSocketId) {
              if (this.roomChatId != this.checkSocketId) {
                this.checkRoomSocketStatus = true
                this.socketCheck.close();
              }
            }
            // Web Socket Started Method Here
            if (this.roomChatId != this.checkSocketId) {
              var _self = this
              var socketCheck = new WebSocket(
                'wss://' + process.env.VUE_APP_WEBSOCKET_BASE_URL +
                '/ws/chat/' + this.roomChatId + '/'
              );
              this.checkSocketId = socketCheck.url.split('/')[5]
              this.socketCheck = socketCheck
              var selectedUserId = _self.selectedChatFromUserDetails.id
              if (videoSocketRef.isOpen()) {
                videoSocketRef.emit({
                  type: "messageIndicationForChat",
                  selfUserID: _self.selfUserId,
                  targetForChatUserId: _self.selectedChatFromUserDetails.id,
                  second_user_id: _self.selectedChatFromUserDetails.id
                });
              }
              socketCheck.onclose = function (e) {
              };
              socketCheck.onmessage = function (e) {
                var data = JSON.parse(e.data);
                var message = JSON.parse(data.message);
                var li = document.createElement("div");
                var div = document.createElement("div");
                var p = document.createElement("div");
                var a = document.createElement("a");
                var fileName = document.createElement("a");
                var img = document.createElement("img");
                var span = document.createElement("span");
                var span2 = document.createElement("span");
                var time_wrp = document.createElement("span");
                var time = document.createElement("time");
                let dateTimeAdd = [moment(message.chat_data.current_time).format('h:mm a')];
                time.appendChild(document.createTextNode(dateTimeAdd));
                time.setAttribute("class", "msg_time");
                time_wrp.setAttribute("class", 'msg_time_wrp');
                li.setAttribute("class", 'live_msg');
                li.appendChild(div);
                p.setAttribute("class", 'chat_in_msg_box_wrp');
                var dropdownDiv = document.createElement("div");
                var msg_toggle_option = document.createElement("span");
                var fa_chevron_down = document.createElement("i");
                var dropdown_menu = document.createElement("ul");
                var reply_li = document.createElement("li");
                var delete_li = document.createElement("li");
                var forwardedMessage_li = document.createElement("li");
                dropdownDiv.setAttribute("class", 'dropdown');
                msg_toggle_option.setAttribute("class", 'msg_toggle_option');
                msg_toggle_option.setAttribute("data-toggle", 'dropdown');
                fa_chevron_down.setAttribute("class", 'fa fa-chevron-down');
                dropdown_menu.setAttribute("class", 'dropdown-menu');
                delete_li.onclick = function () {
                  _self.deteteMessageFromChatMethod(message.chat_data.message_id, message.chat_data.message, message.chat_data.current_time, message.chat_data.selfUserID)
                }
                reply_li.onclick = function () {
                  _self.replyMessageOnChatMethod('userChat', message, 'live')
                }
                forwardedMessage_li.onclick = function () {
                  _self.forwardLiveMsgToUserMethod(message)
                }
                dropdownDiv.appendChild(msg_toggle_option);
                msg_toggle_option.appendChild(fa_chevron_down);
                msg_toggle_option.after(dropdown_menu);
                dropdown_menu.appendChild(reply_li);
                dropdown_menu.appendChild(forwardedMessage_li);
                dropdown_menu.appendChild(delete_li);
                reply_li.appendChild(document.createTextNode('Reply'));
                delete_li.appendChild(document.createTextNode('Delete Message'));
                forwardedMessage_li.appendChild(document.createTextNode('Forward Message'));
                // Forward Label For Code Here
                if(message.forwarded){
                  let forwarded_msg_text = document.createElement("span");
                  let share_icon = document.createElement("i");
                  let forwarded_msg_content = document.createElement("span");
                  forwarded_msg_content.appendChild(document.createTextNode('Forwarded'));
                  forwarded_msg_text.setAttribute("class", 'forwarded_msg_text');
                  share_icon.setAttribute("class", 'fa fa-share');
                  forwarded_msg_text.appendChild(share_icon);
                  share_icon.after(forwarded_msg_content);
                  p.appendChild(forwarded_msg_text)
                }
                // Forward Label For Code Here
                if (message.reply_to_msg) {
                  var show_msg_of_reply_wrp = document.createElement("span");
                  var show_msg_of_reply_name = document.createElement("span");
                  show_msg_of_reply_name.style.color = message.chat_data.colour
                  show_msg_of_reply_wrp.style.borderLeftColor = message.chat_data.colour
                  var show_msg_of_reply_txt = document.createElement("span");
                  show_msg_of_reply_wrp.setAttribute("class", 'show_msg_of_reply_wrp');
                  show_msg_of_reply_name.setAttribute("class", 'show_msg_of_reply_name');
                  show_msg_of_reply_txt.setAttribute("class", 'show_msg_of_reply_txt');
                  show_msg_of_reply_name.appendChild(document.createTextNode(message.reply_to_msg.data.sender_user_detail.first_name + ' ' + message.reply_to_msg.data.sender_user_detail.last_name));
                  if (message.reply_to_msg.data.file_is) {
                    show_msg_of_reply_txt.appendChild(document.createTextNode(message.reply_to_msg.data.filename))
                  } else {
                    show_msg_of_reply_txt.appendChild(document.createTextNode(message.reply_to_msg.data.message))
                  }
                  show_msg_of_reply_wrp.appendChild(show_msg_of_reply_name);
                  show_msg_of_reply_name.after(show_msg_of_reply_txt);
                  p.appendChild(show_msg_of_reply_wrp);
                }
                p.appendChild(dropdownDiv);
                li.setAttribute("id", 'chatMessageId' + message.chat_data.message_id);
                if (message.chat_data.is_file) {
                  div.setAttribute("id", 'live_msg_in_file_recieved');
                  var msgExt = message.message.substr((message.message.lastIndexOf('.') + 1));
                  msgExt = msgExt.substring(0, msgExt.lastIndexOf("?"))
                  li.appendChild(div);
                  div.appendChild(p);
                  p.appendChild(span);
                  span.setAttribute("class", 'msg_in_file');
                  if (msgExt == 'PNG' || msgExt == 'png' || msgExt == 'jpeg' || msgExt == 'jpg' || msgExt == 'svg' || msgExt == 'gif' || msgExt == 'webp') {
                    img.setAttribute("src", message.message);
                    var msg_img_render_in_chat = document.createElement("span");
                    msg_img_render_in_chat.setAttribute("class", 'msg_img_render_in_chat');
                    span.appendChild(msg_img_render_in_chat);
                    msg_img_render_in_chat.appendChild(a);
                    a.setAttribute("href", message.message);
                    a.setAttribute("target", "_new");
                    a.appendChild(img);
                    img.setAttribute("class", 'img-fluid');
                  } else {
                    img.setAttribute("src", _self.checkFileExtensionForChatMessage(message.message));
                    var msg_file_render_in_chat = document.createElement("span");
                    msg_file_render_in_chat.setAttribute("class", 'msg_file_render_in_chat');
                    span.appendChild(msg_file_render_in_chat);
                    msg_file_render_in_chat.appendChild(a);
                    a.setAttribute("href", message.message);
                    a.setAttribute("target", "_new");
                    a.appendChild(img);
                    img.setAttribute("class", 'img-fluid');
                    var msg_file_name = document.createElement("span");
                    msg_file_name.setAttribute("class", 'msg_file_name');
                    msg_file_name.appendChild(document.createTextNode(message.message.split('/').slice(-1)[0].split('?')[0]));
                    img.after(msg_file_name)
                  }
                  if (message.chat_data.message) {
                    fileName.appendChild(document.createTextNode(message.chat_data.message));
                    fileName.setAttribute("href", message.message);
                    fileName.setAttribute("class", 'msg_link');
                    span.after(fileName);
                  }
                  span2.appendChild(time);
                  span2.setAttribute("class", 'msg_time_wrp');
                  p.appendChild(span2);
                } else {
                  if (message.chat_data.message.split(':/')[0] == 'http' || message.chat_data.message.split(':/')[0] == 'https') {
                    a.setAttribute("href", message.chat_data.message);
                    a.setAttribute("target", "_new");
                    a.setAttribute("class", 'hyper_link');
                    a.appendChild(document.createTextNode(message.chat_data.message));
                    p.appendChild(a);
                    div.appendChild(p);
                    time_wrp.appendChild(time);
                    p.appendChild(time_wrp);
                  } else {
                    a.setAttribute("href", "javascript:void(0)");
                    a.setAttribute("class", 'msg_link_chat');
                    a.appendChild(document.createTextNode(message.chat_data.message));
                    p.appendChild(a);
                    div.appendChild(p);
                    time_wrp.appendChild(time);
                    p.appendChild(time_wrp);
                  }
                }
                if (message.chat_data.user_id == selectedUserId) {
                  var labelReadS = document.createElement("label")
                  var labelReadI = document.createElement("i")
                  labelReadS.setAttribute("class", 'chat_msg_send_received_action_wrp');
                  if (message.chat_data.is_read) {
                    labelReadI.setAttribute("class", 'msg_indication msg_read_ind');
                  } else {
                    if (message.chat_data.read_status_value == 'sent') {
                      labelReadI.setAttribute("class", 'msg_indication msg_sent_ind');
                    } else {
                      labelReadI.setAttribute("class", 'msg_indication msg_unsent_ind')
                    }
                  }
                  labelReadS.appendChild(labelReadI);
                  time.after(labelReadS);
                  div.setAttribute("class", 'recieved');
                } else {
                  div.setAttribute("class", 'sent');
                }
                // Forward Multiple Checkbox Code Start
                var radioLabel = document.createElement('label');
                radioLabel.setAttribute('class', 'live_msg_f_label');
                radioLabel.setAttribute('for', 'msg_input' + message.chat_data.message_id);
                var customCheckboxSpan = document.createElement('span');
                customCheckboxSpan.setAttribute('class', 'custom_checkbox_span');
                var customCheckboxI = document.createElement('i');
                customCheckboxI.setAttribute('class', 'fa fa-check');
                var radioInput = document.createElement('input');
                var radioInput = document.createElement('input');
                radioInput.setAttribute('type', 'checkbox');
                radioInput.setAttribute('id', 'msg_input' + message.chat_data.message_id);
                radioInput.setAttribute('hidden', 'true');
                radioInput.onclick = function () {
                  _self.forwardMsgCheckboxMethod(message, message.chat_data.message_id)
                }
                customCheckboxSpan.appendChild(customCheckboxI);
                radioLabel.appendChild(radioInput);
                radioLabel.appendChild(customCheckboxSpan);
                li.appendChild(radioLabel);
                // Forward Multiple Checkbox Code Start
                messagesList.appendChild(li);
                var elmnt = document.getElementById("chat_msg_list_scroll");
                var y = elmnt.scrollHeight;
                $('#chat_msg_list_scroll').scrollTop(y)
              };
            }
          })
        }
      }
    },
    /*
     * This Will File Sent In Chat Method Here
     */
    onInputClick(event) {
      event.target.value = ''
    },
    handleFileUpload(event) {
      this.imgSrc = ''
      if (event.target.files && event.target.files.length > 0) {
        this.uploadFile = event.target.files[0];
        this.filename = this.uploadFile.name
        if (event.target.files[0].type.split('/')[0] == 'image') {
          if (typeof FileReader === 'function') {
            const reader = new FileReader();
            reader.onload = (event) => {
              this.imgSrc = event.target.result;
            };
            reader.readAsDataURL(this.uploadFile);
          } else {
            alert('Sorry, FileReader API not supported');
          }
        }
      }
    },
    textareaInputWithFileMethod(e) {
      document.querySelector('#textarea_for_file_input').addEventListener('keydown', event => {
        if (event.key === 'PageUp' || event.key === 'PageDown') {
          const cursorPosition = event.key === 'PageUp' ? 0 : event.target.textLength;
          event.preventDefault();
          event.target.setSelectionRange(cursorPosition, cursorPosition);
        }
      });
      if (this.fileMessage.length >= 1) {
        if (this.fileMessage.split('').slice(-1) == '@' || e.key == '@') {
          this.suggestionUserListStateForFileAttach = true
        }
      } else {
        this.suggestionUserListStateForFileAttach = false
      }
    },
    cancelUploadFile() {
      this.uploadFile = null;
      this.filename = '';
      this.fileMessage = ''
      this.messageContentDraftValue = ''
    },
    /*
     * This Will Check File Extension In Chat
     */
    checkFileExtensionForChatMessage(file) {
      let extension = file.substr((file.lastIndexOf('.') + 1));
      extension = extension.substring(0, extension.lastIndexOf("?"));
      switch (extension) {
        case 'zip':
          return require('@/assets/images/filetype/zip.png')
          break;
        case 'rar':
          return require('@/assets/images/filetype/zip-1.png');
          break;
          break;
        case 'eps':
          return require('@/assets/images/filetype/ai.png')
          break;
        case 'pdf':
          return require('@/assets/images/filetype/pdf.png')
          break;
        case 'css':
          return require('@/assets/images/filetype/css.png')
          break;
        case 'csv':
          return require('@/assets/images/filetype/csv.png')
          break;
        case 'doc':
          return require('@/assets/images/filetype/doc.png')
          break;
        case 'docx':
          return require('@/assets/images/filetype/doc.png')
          break;
        case 'json':
          return require('@/assets/images/filetype/json-file.png')
          break;
        case 'ppt':
          return require('@/assets/images/filetype/ppt.png')
          break;
        case 'pptx':
          return require('@/assets/images/filetype/ppt.png')
          break;
        case 'txt':
          return require('@/assets/images/filetype/txt.png')
          break;
        case 'xls':
          return require('@/assets/images/filetype/xls.png')
          break;
        case 'xlsx':
          return require('@/assets/images/filetype/xls.png')
          break;
        case 'xml':
          return require('@/assets/images/filetype/xml.png')
          break;
        case 'xlsm':
          return require('@/assets/images/filetype/xls.png')
          break;
        case 'py':
          return require('@/assets/images/filetype/python.png')
        case 'cpp':
          return require('@/assets/images/filetype/cpp-file-format-symbol.png')
          break;
        case 'vbb':
          return require('@/assets/images/filetype/coding.png')
          break;
        default:
          return require('@/assets/images/filetype/d_file.png')
      }
    },
    /*
     * This Will Check File Extension In Chat
     */
    checkFileExtension(file) {
      let extension = file.substr((file.lastIndexOf('.') + 1));
      switch (extension) {
        case 'jpg':
          return require('@/assets/images/filetype/jpg.png')
          break;
        case 'jpeg':
          return require('@/assets/images/filetype/jpg.png')
          break;
        case 'png':
          return require('@/assets/images/filetype/png.png')
          break;
        case 'gif':
          return require('@/assets/images/filetype/jpg.png')
          break;
        case 'zip':
          return require('@/assets/images/filetype/zip.png')
          break;
        case 'rar':
          return require('@/assets/images/filetype/zip-1.png');
          break;
          break;
        case 'eps':
          return require('@/assets/images/filetype/ai.png')
          break;
        case 'pdf':
          return require('@/assets/images/filetype/pdf.png')
          break;
        case 'css':
          return require('@/assets/images/filetype/css.png')
          break;
        case 'csv':
          return require('@/assets/images/filetype/csv.png')
          break;
        case 'doc':
          return require('@/assets/images/filetype/doc.png')
          break;
        case 'docx':
          return require('@/assets/images/filetype/doc.png')
          break;
        case 'json':
          return require('@/assets/images/filetype/json-file.png')
          break;
        case 'ppt':
          return require('@/assets/images/filetype/ppt.png')
          break;
        case 'pptx':
          return require('@/assets/images/filetype/ppt.png')
          break;
        case 'txt':
          return require('@/assets/images/filetype/txt.png')
          break;
        case 'xls':
          return require('@/assets/images/filetype/xls.png')
          break;
        case 'xlsx':
          return require('@/assets/images/filetype/xls.png')
          break;
        case 'xml':
          return require('@/assets/images/filetype/xml.png')
          break;
        case 'xlsm':
          return require('@/assets/images/filetype/xls.png')
          break;
        case 'py':
          return require('@/assets/images/filetype/python.png')
        case 'cpp':
          return require('@/assets/images/filetype/cpp-file-format-symbol.png')
          break;
        case 'vbb':
          return require('@/assets/images/filetype/coding.png')
          break;
        default:
          return require('@/assets/images/filetype/d_file.png')
      }
    },
    /*
     * This Will Check File Submitted In MSG Method Here
     */
    fileMsgSubmit() {
      this.submitted = true
      let formData = new FormData();
      var sentUserInfo = this.selectedChatFromUserDetails;
      if (sentUserInfo.is_group_chat === true) {
        let sentData = {
          'message': this.fileMessage,
          type: 'sent',
          email: this.selfUserInfo.email,
          user_id: this.selfUserInfo.id,
          name: this.selfUserInfo.first_name + ' ' + this.selfUserInfo.last_name,
          file_is: true,
          selfUserID: this.selfUserId,
          filename: this.filename
        }
        const currentUserId = localStorage.getItem('LoginedUserID');
        formData.append('chat_room_user', sentUserInfo.id);
        formData.append('message', this.fileMessage);
        formData.append('file', this.uploadFile);
        formData.append('filename', this.filename);
        formData.append('data', JSON.stringify(sentData));
        this.listLoading = true
        // this.$store.dispatch("uploadMsgFileInChatFun", formData)
        axios.post(UploadMsgFileURL, formData, {
          onUploadProgress: progressEvent => {
            this.uploadProgress = Math.round(
              (progressEvent.loaded / progressEvent.total) * 100
            );
          },
        }).then((res) => {
          this.uploadedFileUrl = res.data.data.file
          let socketSentData = {
            'message': this.fileMessage,
            type: 'sent',
            email: this.selfUserInfo.email,
            user_id: this.selfUserInfo.id,
            name: this.selfUserInfo.first_name + ' ' + this.selfUserInfo.last_name,
            is_file: true,
            message_id: res.data.data.id
          }
          this.socketCheck.send(JSON.stringify({
            'message': this.uploadedFileUrl,
            'user': currentUserId,
            'chat_data': socketSentData
          }))
          this.$store.dispatch('getUserChatDetailsByIdFun', {
            id: sentUserInfo.id
          }).then((res) => {
            this.notificationForFileMessageMethod(this.fileMessage, this.filename, true)
            this.messageListResultsDto = res.data.data
            this.chatAllListResults = [].concat(res.data.data.results)
            this.chatRepeatedDateList = [].concat(res.data.data.repeated_dates_arr)
            this.cancelUploadFile();
            document.querySelector('#chat-message-reply-input').value = ''
            $('.live_msg').remove();
            this.listLoading = false
            this.uploadProgress = 0
            this.submitted = false
          })
        }).catch((err) => {
          toast.error(err.data.msg);
          this.listLoading = false
          this.uploadProgress = 0
          this.submitted = false
        })
      } else {
        let sentData = {
          'message': this.fileMessage,
          type: 'sent',
          email: sentUserInfo.email,
          user_id: sentUserInfo.id,
          name: sentUserInfo.first_name + ' ' + sentUserInfo.last_name,
          file_is: true,
          selfUserID: this.selfUserId,
          filename: this.filename
        }
        formData.append('chat_room_user', this.roomChatIdForFile);
        formData.append('message', this.fileMessage);
        formData.append('file', this.uploadFile);
        formData.append('filename', this.filename);
        formData.append('data', JSON.stringify(sentData));
        this.listLoading = true
        axios.post(UploadMsgFileURL, formData, {
          onUploadProgress: progressEvent => {
            this.uploadProgress = Math.round(
              (progressEvent.loaded / progressEvent.total) * 100
            );
          },
        }).then((res) => {
          this.uploadedFileUrl = res.data.data.file
          let socketSentData = {
            'message': this.fileMessage,
            type: 'sent',
            email: sentUserInfo.email,
            user_id: sentUserInfo.id,
            name: sentUserInfo.first_name + ' ' + sentUserInfo.last_name,
            is_file: true,
            selfUserID: this.selfUserId,
            message_id: res.data.data.id
          }
          this.socketCheck.send(JSON.stringify({
            'message': this.uploadedFileUrl,
            'user': sentUserInfo.id,
            'chat_data': socketSentData
          }))
          this.$store.dispatch('getUserChatDetailsByIdFun', {
            id: this.roomChatIdForFile
          }).then((res) => {
            this.notificationForFileMessageMethod(this.fileMessage, this.filename, false)
            this.messageListResultsDto = res.data.data
            this.chatAllListResults = [].concat(res.data.data.results)
            this.chatRepeatedDateList = [].concat(res.data.data.repeated_dates_arr)
            this.cancelUploadFile();
            document.querySelector('#chat-message-reply-input').value = ''
            $('.live_msg').remove();
            this.listLoading = false
            this.uploadProgress = 0
            this.submitted = false
          })
        }).catch((err) => {
          toast.error(err.data.msg);
          this.listLoading = false
          this.uploadProgress = 0
          this.submitted = false
        })
      }
    },
    notificationForFileMessageMethod(message, filename, isGroup) {
      if (isGroup) {
        const currentUserId = localStorage.getItem('LoginedUserID');
        const payload = {
          selfUserID: currentUserId,
          chatRoomId: this.selectedRoomIdForChatStart,
          second_user_id: this.selectedRoomIdForChatStart,
          senderMsgData: this.selfUserInfo.first_name + ' ' + this.selfUserInfo.last_name + ' : ' + message ? message : filename,
          msgSenderFullName: this.selectedChatFromUserDetails.name
        };
        let socketTimeout = setTimeout(function () {
          bus.$emit('newChatMessageOfGroupRoom', payload);
          clearTimeout(socketTimeout);
        }, 1500);
      } else {
        const currentUserId = localStorage.getItem('LoginedUserID');
        const payload = {
          toUserID: this.selectedChatFromUserDetails.id,
          second_user_id: this.selectedChatFromUserDetails.id,
          fromUserID: currentUserId,
          chatRoomId: this.selectedRoomOfChatUpperInfo.chat_room,
          senderMsgData: message ? message : filename,
          msgSenderFullName: this.selfUserInfo.first_name + ' ' + this.selfUserInfo.last_name
        };
        let socketTimeout = setTimeout(function () {
          bus.$emit('newChatMessage', payload);
          clearTimeout(socketTimeout);
        }, 1500);
      }
    },
    fileOpenNewTab(href) {
      window.open(href, '_blank');
    },
    /*
     * This Will Check Blocked User Method Here
     */
    replaceURLsInMsgText(message) {
      if (!message) return;
      var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
      return message.replace(urlRegex, function (url) {
        var hyperlink = url;
        if (!hyperlink.match('^https?:\/\/')) {
          hyperlink = 'http://' + hyperlink;
        }
        return '<a href="' + hyperlink + '" class="hyper_link" target="_blank">' + url + '</a>'
      });
    }
  },
  watch: {
    getSelectedChatRoomData(newVal, oldVal) {
      this.selectedChatFromUserDetails = newVal
      if (!this.selectedChatFromUserDetails) return;
      this.multiMessageOptionEnabled = false
      this.multipleMessageArr = []  
      if (this.msgListOfChat == 'normal') {
        this.userSearchListTabs = false
        if (this.selectedChatFromUserDetails.is_group_chat) {
          this.getUserDetailsWithGroupChatFun(newVal);
        } else {
          this.opnedChatRoomWithSelectedUserFun(newVal);
        }
      }else{
        this.userSearchListTabs = true
        this.searchingUserForPersonalChatMethod(newVal);
      }
    },
    getSelfUserInfoFun() {
      return this.$store.getters.acUserDetailsStateGetters;
    },
    welcomeBlurbStateFunc(newVal, oldVal){
      if(newVal){
        this.welcomeBlurbsPopupState = true
      }
    }
  },
  created() {
    if (this.socketCheck) {
      this.socketCheck.close();
    }
  },
}